module.exports = __webpack_public_path__ + "static/media/18ECA14.0cf22d4c.jpg";